module.exports = __webpack_public_path__ + "static/media/placeholder-ship-image.1184c64e.png";